import { tracking } from '@iwoca/frontend-tracking-library';

function getEnvironment() {
  return ['www.iwoca.co.uk', 'www.iwoca.de'].includes(window.location.host)
    ? 'production'
    : 'development';
}

export const initialise = () => {
  tracking.initialise({
    environment: getEnvironment(),
  });
};

export function identify(data: { stateKey: string; isImpersonating: boolean }) {
  tracking.identifyCustomer({ ...data, country: 'UK' });
}
